*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  user-select: none;
  display: block;
}

.divider {
  height: 1px;
  margin: 4px 8px;
  background-color: var(--wui-color-border, rgb(0 0 0 / 0.1));
}
